/* eslint-disable react/require-default-props */
import React, { useMemo } from 'react';
import { translate } from '@utils/i18n';
import Label from '@components/Label';
function Dropdown({ resourceOptions, resourceName, selectedItem, disabled = false, allowEmpty = true, emptyLabel = translate('unassigned', { namespace: 'features.commons' }), emptyPosition = 'beginning', onChange, id, showLabel = true, inlineLabel = false }) {
    const effectiveId = id || `dropdown-${resourceName}`;
    const createEmptyOption = () => (React.createElement("option", { key: `${resourceName}-unassigned`, value: "" }, emptyLabel));
    const selectOptions = useMemo(() => {
        const options = [];
        if (allowEmpty && emptyPosition === 'beginning') {
            options.push(createEmptyOption());
        }
        options.push(...resourceOptions.map((resource) => (React.createElement("option", { key: `${resourceName}-${String(resource.value)}`, value: String(resource.value) }, resource.label))));
        if (allowEmpty && emptyPosition === 'end') {
            options.push(createEmptyOption());
        }
        return options;
    }, [resourceOptions, allowEmpty, emptyPosition, emptyLabel, resourceName]);
    const handleChange = (e) => {
        const selectedValue = e.target.value;
        if (selectedValue === '') {
            onChange(null);
            return;
        }
        const selectedResource = resourceOptions.find((resource) => String(resource.value) === selectedValue);
        if (selectedResource) {
            onChange(selectedResource.value);
        }
        else {
            onChange(null);
        }
    };
    return (React.createElement("div", { className: inlineLabel ? '' : 'qmb-select--x-full selectContainer', style: inlineLabel ? { display: 'flex', alignItems: 'center', gap: 8 } : {} },
        showLabel && (React.createElement(Label, { htmlFor: effectiveId, style: inlineLabel ? { marginRight: 2, marginBottom: 0 } : {} },
            resourceName,
            ":")),
        React.createElement("select", { id: effectiveId, className: "qmb-inedit--dropdown", value: selectedItem || '', onChange: handleChange, disabled: disabled, "aria-label": resourceName, style: inlineLabel ? { marginBottom: 0 } : {} }, selectOptions)));
}
export default Dropdown;
